import store from "../../store";
import user_auth from './index.vue';

window.USER =  new Vue({
    store,
    el: 'div#user_auth',

    data () {
        return {

        }
    },
    created () {

    },
    components : {
        user_auth,
    }
});
